import { useRouteLoaderData } from 'react-router';
import type { loader } from '~/routes/layout';

export function useUser() {
  const data = useRouteLoaderData<typeof loader>('routes/layout');
  return data?.user;
}
